import { render, staticRenderFns } from "./ThankYouOtp.vue?vue&type=template&id=05347442&scoped=true"
import script from "./ThankYouOtp.vue?vue&type=script&lang=js"
export * from "./ThankYouOtp.vue?vue&type=script&lang=js"
import style0 from "./ThankYouOtp.vue?vue&type=style&index=0&id=05347442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05347442",
  null
  
)

export default component.exports